import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Paper, Stack, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useAuthStore } from '../../store/authStore';
import SubscriptionGuard from '../SubscriptionGuard';
import theme from '../corebase/theme/corebaseTheme';
import ProjectBaseCore from './ProjectBaseCore';
import { APP_KEY } from './projectBaseApi';
export function ProjectBaseLanding() {
  const navigate = useNavigate();
  return <Container maxWidth="lg"><Paper sx={{
      p: {
        xs: 3,
        md: 6
      },
      background: 'linear-gradient(120deg,#0B213A,#173E68)',
      color: 'white',
      borderRadius: 4
    }}><Typography variant="overline" sx={{
        color: '#91CAFF'
      }}>PROJECTBASE PM · DEVS SOFT</Typography><Typography variant="h3" sx={{
        fontWeight: 800,
        my: 2,
        fontSize: {
          xs: 34,
          md: 52
        },
        maxWidth: 750
      }}>Cada recurso cuenta.<br />Cada proyecto tiene un propósito.</Typography><Typography sx={{
        maxWidth: 640,
        color: '#CDDBEC',
        mb: 4
      }}>Planifica cursos, talleres y proyectos. Coordina personas, anticipa faltantes y comprueba los resultados desde un solo lugar. Gratis, sin suscripción.</Typography><Stack direction={{
        xs: 'column',
        sm: 'row'
      }} gap={2}><Button variant="contained" onClick={() => navigate('/login')}>Comenzar gratis</Button><Button sx={{
          color: 'white'
        }} onClick={() => navigate('/account/mcp-access')}>Gestionar acceso del asistente</Button></Stack></Paper><Box sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: '1fr',
        md: 'repeat(3,1fr)'
      },
      gap: 2,
      my: 3
    }}>{[['Planifica con intención', 'Resultados, actividades y responsables conectados.'], ['Cuida tu capacidad', 'Horarios, disponibilidad y uso real de recursos.'], ['Decide con evidencia', 'Alertas verificables y escenarios antes de ajustar.']].map(([title, body]) => <Paper key={title} variant="outlined" sx={{
        p: 3
      }}><Typography variant="h6">{title}</Typography><Typography color="text.secondary" mt={1}>{body}</Typography></Paper>)}</Box></Container>;
}
export default function ProjectBaseApp() {
  const userId = useAuthStore(s => s.user?._id);
  return <ThemeProvider theme={theme}><SubscriptionGuard appKey={APP_KEY} appName="ProjectBase PM" landing={<ProjectBaseLanding />}>{userId && <ProjectBaseCore key={userId} />}</SubscriptionGuard></ThemeProvider>;
}
